export const getRouterColor = (brand: string) => {
  const brandColors: Record<string, string> = {
    // Big ISPs devices brands
    Intelbras: '#00A335', // caracteristic green
    Huawei: '#ED1C24', // red
    ZTE: '#005193', // dark blue
    Nokia: '#1241FF', // blue
    FiberHome: '#231F20', // dark grey // black

    // common brand and mesh wi-fi
    'TP-Link': '#4ACBD6', // Turquoise/Cyan
    Mercusys: '#FF0000', // Vivid red
    'D-Link': '#0070AD', // royal blue
    Asus: '#000000', // black
    Tenda: '#FF6600', // orange

    // infraestructure equipment and radio
    MikroTik: '#31A4CF', // light blue
    Ubiquiti: '#0055FF', // blue (UniFi/AirMax)
    Datacom: '#E30613', // red (national)
    Parks: '#004A99', // blue marine (national)

    // FTTH ONU/ONT and chipset vendors
    VSOL: '#E50012', // red
    'V-SOL': '#E50012', // alternate spelling
    Shoreline: '#1C5D80', // teal blue
    SHLN: '#1C5D80', // Shoreline's short vendor name
    Realtek: '#0078AF', // blue

    // others
    Cisco: '#049FD9', // celestial blue
    Zyxel: '#0061A9', // blue
  };

  // normalize brand name
  const normalizedBrand = Object.keys(brandColors).find(
    (key) => key.toLowerCase() === brand?.split(' ')[0].toLowerCase()
  );

  if (normalizedBrand)
    return brandColors[normalizedBrand] + 'AA'; // default color to not mapped colors
  else return '#8884d8';
};
